import { useWindowSize } from "@octano/global-ui"


export const useTable = () => {
  const size = useWindowSize()
  return (size.width || 0) <= 768
}
